<template>
    <div class="project-box">
        <div class="backgroundTop"></div>
        <div class="projectArray" @mouseover='mouseIn' @mouseout='mouseOut'>
            <!-- pc -->
            <swiper ref="mySwiper" :options="swiperOptions" class="mySwiper">
                <swiper-slide class='swiperSlider' v-for='(item,index) in swiperData' :key='index'>
                    <div class="item-box">
                        <div class="item-img-box">
                            <img :src="item.imgurl" alt="案例" class="imgitem">
                        </div>
                        <h4 class="item-caption">{{item.caption}}</h4>
                    </div>
                </swiper-slide>
                <div class="swiper-scrollbar" slot="scrollbar"></div>
            </swiper>
            <!-- mobile -->
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Project',
        data() {
            return {
                swiperOptions: {
                    // autoplay: { //匀速滚动
                    //     delay: 1, //间隔时间0秒
                    //     stopOnLastSlide: false,
                    //     disableOnInteraction: false, //触摸后仍然执行
                    // },
                    // scrollbar: {
                    //     el: '.swiper-scrollbar',
                    //     // hide: true,
                    //     draggable: true,
                    // },
                    // loop: true,
                    // speed: 16000,  //设置图片滚动速度
                    // slidesPerView: 1.5,
                    // spaceBetween: 94,
                    // // freeMode: true,
                    // grabCursor: true,
                    // // centeredSlides: true,
                    // // Some Swiper option/callback...
                },
                swiperDataOption1: {
                    // autoplay: { //匀速滚动
                    //     delay: 1, //间隔时间0秒
                    //     stopOnLastSlide: false,
                    //     disableOnInteraction: false, //触摸后仍然执行
                    // },
                    autoplay:false,
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        // hide: true,
                        draggable: true,
                    },
                    loop: true,
                    speed: 16000,  //设置图片滚动速度
                    slidesPerView: 1.5,
                    spaceBetween: 94,
                    // freeMode: true,
                    grabCursor: true,
                    // centeredSlides: true,
                    // Some Swiper option/callback...
                },
                swiperDataOption2: {
                    autoplay: { //匀速滚动
                        delay: 1, //间隔时间0秒
                        stopOnLastSlide: false,
                        disableOnInteraction: false, //触摸后仍然执行
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        // hide: true,
                        draggable: true,
                    },
                    loop: true,
                    speed: 16000,  //设置图片滚动速度
                    slidesPerView: 1,
                    spaceBetween: 10,
                    // freeMode: true,
                    grabCursor: true,
                    // centeredSlides: true,
                    // Some Swiper option/callback...
                },
                swiperData: [
                    {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/mairui.jpg',
                        caption: '智能照明行业',
                    },
                    {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/rixing.jpg',
                        caption: '智能锁行业',
                    },
                    {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/%E7%BB%84%20594.jpg',
                        caption: '水暖阀门行业',
                    },
                    {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/mairui.jpg',
                        caption: '智能照明行业',
                    },
                    {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/rixing.jpg',
                        caption: '智能锁行业',
                    },
                    {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/%E7%BB%84%20594.jpg',
                        caption: '水暖阀门行业',
                    },
                ]
            }
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            }
        },
        created() {
            this.getscreen()
        },
        mounted() {
            // console.log('Current Swiper instance object', this.swiper)
            this.changeSwiperCss()
            // this.swiper.slideTo(3, 1000, false)
        },
        methods: {
            changeSwiperCss() {
                this.swiper.$wrapperEl.css({ '-webkit-transition-timing-function': "linear", "-moz-transition-timing-function": "linear", "-ms-transition-timing-function": "linear", "-o-transition-timing-function": "linear", "transition-timing-function": "linear" });
            },
            mouseIn() {
                this.swiper.autoplay.stop()

            },
            mouseOut() {
                this.swiper.autoplay.start()
            },
            getscreen() {
                const screenWidth = document.documentElement.getBoundingClientRect().width || document.body.getBoundingClientRect().width
                screenWidth > 995 ? this.swiperOptions = this.swiperDataOption1 : this.swiperOptions = this.swiperDataOption2
            }
        }
    }
</script>
<style scoped>
    .project-box {
        /* padding-bottom: 541px; */
        position: relative;
    }

    .backgroundTop {
        min-height: 639px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/photo-1522542550221-31fd19575a2d.jpg') no-repeat center center;
        background-size: cover;
        background-attachment: fixed;
    }

    .projectArray {
        width: 100%;
        height: auto;
        position: relative;
        top: -200px;
        left: 0;
        background-color: transparent;
    }



    .swiperBox,
    .mySwiper {
        width: 100%;
        height: 100%;
    }

    .swiperSlider {
        background: transparent;
        height: 100%;
    }

    .item-box {
        width: 100%;
        height: 100%;
        background-color: transparent;
    }

    .item-img-box {
        /* height: 703px;
        background: #f9f9f9 no-repeat center center;
        background-size: cover; */
        /* border: 1px solid #1f1f1f; */
    }

    .imgitem {
        width: 100%;
    }

    .item-caption {
        font-size: 16px;
        font-weight: 500;
        line-height: 28px;
        color: rgba(153, 153, 153, 1);
        margin-top: 21px;
        padding-bottom: 5%;
    }

    .item-center-box>>>p {
        font-size: 16px;
        font-weight: 300;
        line-height: 28px;
        color: rgba(153, 153, 153, 1);
    }

    @media(max-width: 995px) {
        .backgroundTop {
            min-height: 139px;
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/photo-1522542550221-31fd19575a2d.jpg') no-repeat center;
            background-size: cover;
            background-attachment: initial;
        }

        .projectArray {
            width: 100%;
            height: auto;
            top: 0;
            left: 0;
            background-color: transparent;
        }
    }

    /* @media(max-width: 1023px) {
        .project-box {
        padding-bottom: 841px;
    }
        .backgroundTop {
            height: 639px;
            background-attachment: initial;
        }

        .projectArray {
            width: 100%;
            height: 1090px;
        }

        .item-img-box {
            width: 100%;
            height: 95%;
            background: #f9f9f9 no-repeat center;
            background-size: cover;
            border: none;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/home/project.vue